import { render, staticRenderFns } from "./corporate-client-management-box.vue?vue&type=template&id=7fc532ba&scoped=true"
import script from "./corporate-client-management-box.vue?vue&type=script&lang=js"
export * from "./corporate-client-management-box.vue?vue&type=script&lang=js"
import style0 from "./corporate-client-management-box.vue?vue&type=style&index=0&id=7fc532ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc532ba",
  null
  
)

export default component.exports